module.exports = __webpack_public_path__ + "static/media/tyres_normal.0eaec46f.jpg";